<template>
    <b-col class="AddNewChurch">
        <b-form class="full-width" @submit="AddChurch">
            <b-row>
                <b-col lg="6">
                    <h2>Church Information</h2>
                    <div class="form-group">
                        <label>Church Name:</label>
                        <input type="text" v-model="NewChurch.Name" class="form-control" required />
                    </div>
                    <div class="form-group">
                        <label>Physical Address:</label>
                        <input type="text" v-model="NewChurch.AddressPhysicalLine1" class="form-control" required placeholder="Address Line 1" />
                        <input type="text" v-model="NewChurch.AddressPhysicalLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                        <b-row>
                            <div class="col-5 no-padding">
                                <input type="text" v-model="NewChurch.AddressPhysicalCity" class="form-control" required placeholder="City" />
                            </div>
                            <div class="col-3 no-padding">
                                <select class="form-control" v-model="NewChurch.AddressPhysicalState" required>
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-4 no-padding">
                                <input type="number" v-model="NewChurch.AddressPhysicalZip" class="form-control" required placeholder="Zip" :state="ZipCodeMatch" minlength="5" maxlength="5"/>
                            </div>
                        </b-row>
                    </div>
                    <div class="form-group">
                        <label>Mailing Address:</label> <font-awesome-icon :icon="['fa', 'robot']" @click="CopyPhysicalAddress" class="pointer" />
                        <input type="text" v-model="NewChurch.AddressMailingLine1" class="form-control" required placeholder="Address Line 1" />
                        <input type="text" v-model="NewChurch.AddressMailingLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                        <b-row>
                            <div class="col-5 no-padding">
                                <input type="text" v-model="NewChurch.AddressMailingCity" class="form-control" required placeholder="City" />
                            </div>
                            <div class="col-3 no-padding">
                                <select class="form-control" v-model="NewChurch.AddressMailingState" required>
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-4 no-padding">
                                <input type="number" v-model="NewChurch.AddressMailingZip" class="form-control" required placeholder="Zip" minlength="5" maxlength="5"/>
                            </div>
                        </b-row>
                    </div>
                    <div class="form-group">
                        <label>Territory:</label>
                        <select class="form-control" v-model="NewChurch.Region" required disabled>
                            <option value="Unspecified" selected>Unspecified</option>
                            <option value="High Desert">High Desert</option>
                            <option value="Low Desert">Low Desert</option>
                            <option value="Mid County">Mid County</option>
                            <option value="West Riverside County">West Riverside County</option>
                            <option value="South Riverside County">South Riverside County</option>
                            <option value="South SB County">South SB County</option>
                        </select>
                    </div>
                </b-col>
                <b-col lg="6">
                    <h2>Regional Program Enrollment</h2>
                    <div class="form-group">
                        <label>Regional Program:</label>
                        <select class="form-control" v-model="NewChurch.SubProgramID" required>
                            <option v-for="option in SubProgramOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Relationship Start Date</label>
                        <flat-pickr v-model="NewChurch.StartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Involvement with Safe Families:</label>
                        <select class="form-control" v-model="NewChurch.IsInvolvedWithSafeFamilies" required>
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Involvement with Foster:</label>
                        <select class="form-control" v-model="NewChurch.IsInvolvedWithFoster" required>
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Involvement with Community Involvement:</label>
                        <select class="form-control" v-model="NewChurch.IsInvolvedWithCommunityInvolvement" required>
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                    </div>
                    <button class="btn btn-success form-control" type="submit">
                        <i class="fa fa-plus"></i> Add Church
                    </button>
                </b-col>
            </b-row>
        </b-form>
    </b-col>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faRobot } from '@fortawesome/free-solid-svg-icons';
    library.add(faRobot);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
     
    import { EventBus } from '../../../services/event-bus.js';
    export default {
        props: [],
        data: function () {
            return {
                PageState: "Initial",
                NewChurch: {
                    AddressPhysicalLine1: "",
                    AddressPhysicalLine2: "",
                    AddressPhysicalCity: "",
                    AddressPhysicalState: "",
                    AddressPhysicalZip: "",
                    AddressMailingLine1: "",
                    AddressMailingLine2: "",
                    AddressMailingCity: "",
                    AddressMailingState: "",
                    AddressMailingZip: "",
                    StartDate: "",
                    SubProgramID: "",
                    Name: "",
                    Region: "",
                    IsInvolvedWithFoster: "",
                    IsInvolvedWithSafeFamilies: "",
                    IsInvolvedWithCommunityInvolvement: ""
                },
                ZipCodes: [],
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
            };
        },
        methods: {
            CopyPhysicalAddress() {
                this.NewChurch.AddressMailingLine1 = this.NewChurch.AddressPhysicalLine1;
                this.NewChurch.AddressMailingLine2 = this.NewChurch.AddressPhysicalLine2;
                this.NewChurch.AddressMailingCity = this.NewChurch.AddressPhysicalCity;
                this.NewChurch.AddressMailingState = this.NewChurch.AddressPhysicalState;
                this.NewChurch.AddressMailingZip = this.NewChurch.AddressPhysicalZip;
            },
            AddChurch(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "ChurchEngagement/Church/CreateChurch", this.NewChurch, this.AddChurchSuccess, () => { }, false);
            },
            AddChurchSuccess(response) {
                //switch to client record
                this.$store.commit("Churches.ChurchProfiles.Append", { Church: { Id: response.data.data.Id, Name: this.NewChurch.Name } });
                //this.$set(this.$parent.OpenChildRecords, subProgramMembershipID, childRecordData);
                this.$parent.ChangePaneShown(response.data.data.Id);
                //execute global update
                this.$GlobalUpdate.ExecuteGlobalUpdate();

                //reset page state and form info
                this.ResetPage();
            },
            ResetPage() {
                this.$set(this, 'NewChurch', {
                    AddressPhysicalLine1: "",
                    AddressPhysicalLine2: "",
                    AddressPhysicalCity: "",
                    AddressPhysicalState: "",
                    AddressPhysicalZip: "",
                    AddressMailingLine1: "",
                    AddressMailingLine2: "",
                    AddressMailingCity: "",
                    AddressMailingState: "",
                    AddressMailingZip: "",
                    StartDate: "",
                    SubProgramID: "",
                    Name: "",
                    Region: "",
                    IsInvolvedWithFoster: "",
                    IsInvolvedWithSafeFamilies: "",
                    IsInvolvedWithCommunityInvolvement: ""
                });
            },
            GetZipCodes() {
                this.$MasterAPI.ExecuteRequest("GET", "ChurchEngagement/Church/GetZipCodes", {}, this.GetZipCodesSuccess, () => { }, false);
            },
            GetZipCodesSuccess(response) {
                this.ZipCodes = response.data.data;
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
        },
        computed: {
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            ZipCodeMatch: function () {
                var autoRegion = this.ZipCodes.filter(zipcode => zipcode.Id == this.NewChurch.AddressPhysicalZip);
                if (autoRegion.length == 1) {
                    this.NewChurch.Region = autoRegion[0].ChurchEngagementRegion;
                }
                else if ((autoRegion.length == 0 && this.NewChurch.AddressPhysicalZip.length == 5) || this.NewChurch.AddressPhysicalZip.length <5)
                    this.NewChurch.Region = "Unspecified";
            },
        },
         mounted(){
            this.GetZipCodes();
        }
    }
</script>

<style scoped>
    .no-padding:first-child {
        padding-right: 0px;
    }

    .no-padding:last-child {
        padding-left: 0px;
    }
</style>